import BOM from "@system/config/bom";
import useReduxState from 'src/hooks/useReduxState';
import store from 'src/storeWire';
import { useBOMStore } from 'src/hooks/bom';
import System from 'src/helper/system';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { SET_bomUploadFile__progress_percentage } from 'src/store/slice/model/BOM';
import React, { useState, useEffect } from 'react';
import Helper from 'src/helper/Helper';
import liveAuth from 'src/helper/liveAuth';
import ShowAlert from 'src/component/Global/ShowAlert';

const StartBom = (props) => {
    const [{ bomUploadFile__progress_percentage }, { bom_upload_file }, { download_bom_template, bom_upload_progress }] = useBOMStore();
    const [type, setType] = useReduxState("upload_file", 'setType');
    const [{ }, { system_alert_indicator, clear_all_system_alert }, { }] = useDOMAttachToSystemStore();
    const [errorMsgs, setErrorMsgs] = useState([]);
    const { storageName: { GUEST_BOM_ID, FLASH_MESSAGE, BOM_UPLOAD_FILE } } = System;
    const [fileEvent, setFileEvent] = useState({ file: '', event: '' });
    const [confirmWarning, setConfirmWarning] = useState(false)
    const [dragActive, setDragActive] = useState(false);
    const gestUser = !liveAuth.check()
    const typeHandler = (type) => {
        setType(type);
    };

    const downloadBomTemplate = async () => {
        await download_bom_template();
    }

    const progressBarCalculation = async (bomId) => {
        let res = await bom_upload_progress({ bomId: bomId });
        let progressStatus = parseInt(parseInt(res.totalProcessed * 100.0) / parseInt(res.totalMatches));
        if (progressStatus >= 100) {
            store.dispatch(SET_bomUploadFile__progress_percentage({
                percentage: 100
            }));
            window.location.href = BOM.getBomDetailByIdRouteURL(
                bomId,
                {
                    go: System.getParams().go,
                    isReRunPartMatch: false
                }
            );
            return;
        }
        let per = progressStatus > 0 ? progressStatus : 0.1;
        store.dispatch(SET_bomUploadFile__progress_percentage({
            percentage: per
        }));
        setTimeout(() => {
            progressBarCalculation(bomId);
        }, 1200);
    }

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setErrorMsgs([]);
        clear_all_system_alert({})
        setDragActive(false);

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            if (gestUser) {
                if (localStorage.getItem(GUEST_BOM_ID)) {
                    setFileEvent({ file: e.dataTransfer.files, event: e });
                    openWarningPopup(e);
                } else {
                    handleFileUpload(e.dataTransfer.files, e);
                }
            } else {
                handleFileUpload(e.dataTransfer.files, e);
            }
        }
    };


    const handleChange = (e) => {
        e.preventDefault();
        setErrorMsgs([]);
        clear_all_system_alert({})
        if (e.target.files && e.target.files[0]) {
            if (gestUser) {
                if (localStorage.getItem(GUEST_BOM_ID)) {
                    setFileEvent({ file: e.target.files, event: e });
                    openWarningPopup(e);
                } else {
                    handleFileUpload(e.target.files, e);
                }
            } else {
                handleFileUpload(e.target.files, e);
            }
        }
    };

    const handleFileUpload = async (files, event) => {
        let file = files[0];
        const extension = file.name.substring(file.name.lastIndexOf('.') + 1);
        const size_in_mb = Helper.bytesToMB(file.size);
        if (size_in_mb > 20) {
            event.target.value = null
            system_alert_indicator({
                name: 'bomUploadMoreThen20Mb',
                message: "Your file may have been altered to meet the file requirements for BOM.",
                type: "warning"
            })
            return;
        }
        const validExtensions = ['xls', 'xlsx', 'csv', 'tab', 'txt'];
        if (!validExtensions.includes(extension)) {
            event.target.value = null
            system_alert_indicator({
                name: 'bomUploadFileError',
                message: "Invalid file format. Please upload a valid file",
                type: "danger"
            })
            return;
        }
        store.dispatch(SET_bomUploadFile__progress_percentage({
            percentage: 0.1
        }));
        let file_upload = await bom_upload_file({ file, source: 'upload' });
        if (file_upload.isSuccessFull && file_upload.data) {
            try {
                if (file_upload.data.errorMessage && JSON.parse(file_upload.data.errorMessage).length > 0 && JSON.parse(file_upload.data.errorMessage)[0]) {
                    localStorage.setItem(FLASH_MESSAGE, JSON.parse(file_upload.data.errorMessage)[0].Message);
                }

            } catch (e) { }
            try {
                localStorage.setItem(BOM_UPLOAD_FILE, true);
            } catch (e) { }

            let _bomId = file_upload.data && file_upload.data.bomId && file_upload.data.bomId.trim() !== '' ? file_upload.data.bomId : '';

            if (_bomId !== '') {
                localStorage.setItem("adobeEventType", "bomFileUpload");
                if (file_upload.errorCode && file_upload.errorCode === 'BOM001') {
                    window.location.href = BOM.getBomRematchRouteURL({ bomId: _bomId });
                } else {
                    await progressBarCalculation(_bomId);
                }
            }
        } else {
            store.dispatch(SET_bomUploadFile__progress_percentage({
                percentage: 0
            }));
            if (file_upload.errorMessage) {
                const errMessage = JSON.parse(file_upload.errorMessage);
                setErrorMsgs(errMessage);
            }
        }
        event.target.value = null
    };

    useEffect(() => {
        if (fileEvent.file) {
            handleFileUpload(fileEvent.file, fileEvent.event);
        }
    }, [confirmWarning])

    const warningCallBack = () => {
        setConfirmWarning(!confirmWarning)
    };

    const openWarningPopup = (e) => {
        System.popup('BomWarningPopUp', { warningCallBack: warningCallBack, event: e });
    };


    useEffect(() => {
        if (errorMsgs.length > 0) {
            errorMsgs.map((v, i) => (
                system_alert_indicator({
                    name: 'bomUploadErrorMsgs' + i,
                    message: v.Message,
                    type: "danger"
                })
            ))
        }
    }, [errorMsgs])

    return (
        <>
            <div className="select-bom">
                <ShowAlert onlyShowMessage={['bomUploadErrorMsgs0', 'bomUploadErrorMsgs1', 'bomUploadErrorMsgs2']} />
                <div className="d-flex justify-content-between align-items-stretch">
                    <div className="select-bom-left">
                        <h2 className="m-b-20 mt-0">Start a BOM</h2>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="type"
                                checked={type === "upload_file"} id="upload_file" value="upload_file"
                                onChange={(e) => typeHandler(e.target.value)} />
                            <label className="form-check-label mt-0 m-b-15" htmlFor="upload_file">
                                Upload File
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="type"
                                checked={type === "bom_template"} id="bom_template" value="bom_template"
                                onChange={(e) => typeHandler(e.target.value)} />
                            <label className="form-check-label mt-0 m-b-15" htmlFor="bom_template">
                                BOM Template
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="type"
                                checked={type === "create_parts_list"} id="create_parts_list"
                                value="create_parts_list"
                                onChange={(e) => typeHandler(e.target.value)} />
                            <label className="form-check-label mt-0 m-b-15" htmlFor="create_parts_list">
                                Create Parts List
                            </label>
                        </div>
                        <div className="form-check mb-0">
                            <input className="form-check-input" type="radio" name="type" checked={type === "find_part"}
                                id="find_part" value="find_part"
                                onChange={(e) => typeHandler(e.target.value)} />
                            <label className="form-check-label mt-0 m-b-0" htmlFor="find_part">
                                Find a Part
                            </label>
                        </div>
                    </div>
                    <div className="select-bom-right bom_file_upload">
                        {type === "upload_file" &&
                            <>
                                <form id="label-file-upload" htmlFor="input-file-upload"
                                    className={dragActive ? "bom-file-upload drag-active" : "bom-file-upload"}
                                    onDragEnter={handleDrag}
                                    onSubmit={(e) => e.preventDefault()}>
                                    {bomUploadFile__progress_percentage <= 0.1 && !(bomUploadFile__progress_percentage > 0 && bomUploadFile__progress_percentage < 100) &&
                                        <>
                                            <ShowAlert onlyShowMessage={['bomUploadMoreThen20Mb', 'bomUploadFileError']} />
                                            <input type="file" id="input-file-upload" multiple={false}
                                                style={{ display: 'none' }}
                                                onChange={handleChange} />
                                            <h4 className="font-18">Drag your BOM file here to upload
                                                <div className="or-text">or</div>
                                            </h4>
                                            <label className="btn bs5 btn-primary upload-button w160" htmlFor="input-file-upload">
                                                Select a file
                                            </label>
                                            <div className="font-bold font-16 mt-3 mb-1 font-arial">
                                                Maximum file size 20MB and 1000 lines. File types accepted xls, xlsx, csv, tab, txt.
                                            </div>
                                        </>
                                    }
                                    {bomUploadFile__progress_percentage > 0 && bomUploadFile__progress_percentage < 100 &&
                                        <div>
                                            <div className="progress-bar-container" id="bomUploadProgress">
                                                <div className="progress-bar" id="bomUploadBar"
                                                    style={{ width: bomUploadFile__progress_percentage + "%" }} />
                                            </div>
                                            <p>
                                                Maximum file size 20MB, 10 columns and 1000 lines. File types accepted xls, xlsx, csv, tab, txt.
                                            </p>
                                            <div>
                                                Please ensure that the first row in your upload files is column headers.
                                            </div>
                                        </div>
                                    }
                                </form>
                                {dragActive && <div className="drag-file-element"
                                    onDragEnter={handleDrag} onDragLeave={handleDrag}
                                    onDragOver={handleDrag} onDrop={handleDrop} />}
                            </>
                        }

                        {type === "bom_template" && <div className="bom-file-upload">
                            <h4 className="font-18 m-b-15">The BOM template will help eliminate errors </h4>
                            <button className="btn bs5 btn-primary"
                                onClick={() => downloadBomTemplate()}>DOWNLOAD TEMPLATE
                            </button>
                        </div>}

                        {type === "create_parts_list" && <div className="bom-file-upload">
                            <h4 className="font-18 m-b-15">Copy/Paste or create multiple parts list.</h4>
                            <button className="btn bs5 btn-primary w130" data-toggle="modal" data-target="#add-parts"
                                onClick={() => {
                                    System.popup('CreatePartPopup', { title: "Create parts list", addFrom: "AddPart" })
                                }}>Add parts
                            </button>
                        </div>}

                        {type === "find_part" && <div className="bom-file-upload">
                            <h4 className="font-18 m-b-15">Find and add a part to your BOM</h4>
                            <button className="btn bs5 btn-primary w130" data-toggle="modal" data-target="#find-parts"
                                onClick={() => {
                                    System.popup('FindPartPopup', { addFrom: "FindPart" })
                                }}>Find Part

                            </button>
                        </div>}


                    </div>
                </div>
            </div>
        </>
    );
}

export default StartBom;